import { createAction } from 'redux-actions';

export const openAction = createAction('@@overlay/OPEN_OVERLAY');
export const closeAction = createAction('@@overlay/CLOSE_OVERLAY');

export const openOverlay = (name, props = {}, size = 600, x = undefined, y = undefined) =>
  openAction({ name, props, size, x, y });
export const closeOverlay = (name) => closeAction({ name });
export const clearOverlay = createAction('@@overlay/CLEAR_OVERLAY');

export const getOverlay = (state, name) => state.overlay[name] || {};